import {useAttendeeVariables, useGuestVariables} from 'Event'
import {LoginProps} from 'Event/auth/Login'
import Button from 'Event/auth/Login/SubmitButton/Button'
import SubmitButtonConfig from 'Event/auth/Login/SubmitButton/SubmitButtonConfig'
import {useEditMode} from 'Event/EditModeProvider'
import {useTemplate} from 'Event/TemplateProvider'
import Configurable from 'organization/Event/Configurable'
import React from 'react'

export default function SubmitButton(props: LoginProps) {
  const isEditMode = useEditMode()
  const v = useGuestVariables()
  const {login} = useTemplate()

  if (isEditMode) {
    return <ConfigurableSubmitButton {...props} />
  }

  return (
    <Button disabled={props.submitting} aria-label="submit login">
      {v(login.submitButton.label)}
    </Button>
  )
}

function ConfigurableSubmitButton(props: LoginProps) {
  const v = useAttendeeVariables()
  const {login} = useTemplate()

  return (
    <Configurable>
      <SubmitButtonConfig />
      <Button disabled={props.submitting} aria-label="submit login">
        {v(login.submitButton.label)}
      </Button>
    </Configurable>
  )
}
